export default function StreamOutputStatusErrorLine({ error_message }) {
  return (<div className="flex m-px">
    <div className="flex m-px border border-gray-200 rounded-md">
      <div className="px-2 w-18 bg-gray-100 rounded-l-md">status:</div>
      <span className="text-red-500 px-2 w-36">{error_message}</span>
    </div>
  </div>);
}
